import { FETCH_INVITES, FETCH_USERS, USER_ALERT_DISPLAY } from '../constants/admin';

const initialState = {
    users: [],
    invites: [],
    alertDisplay: {}
};

export default function(state = {}, action) {
    switch (action.type) {
        case FETCH_USERS:
            return {
                ...state,
                users: action.payload
            };
        case USER_ALERT_DISPLAY:
            return {
                ...state,
                alertDisplay: action.payload
            };
        case FETCH_INVITES:
            return {
                ...state,
                invites: action.payload
            };
        default:
            return state;
    }
}
